import { styled } from 'styled-components';

// flyout panel for "New Filter"
export const PlayFinderFilterConfigWrapper = styled.div`
  position: fixed;
  top: 0;
  left: ${({ $left }) => $left || '-768px'};
  width: 768px;
  height: 100vh;
  z-index: 9999;
  transition: left ${({ theme }) => theme.animation.duration.slow}
    ${({ theme }) => theme.animation.easing.moving};
  scrollbar-gutter: stable;
`;
PlayFinderFilterConfigWrapper.displayName = 'PlayFinderFilterConfigWrapper';

// flyout panel footer, a modification of SummaryTileFooter
export const PlayFinderTileFooter = styled.div`
  position: absolute;
  display: flex;
  padding: 0 ${({ theme }) => theme.sizing.medium};
  justify-content: flex-end;
  align-items: center;
  height: 48px;
  bottom: 0;
  width: 100%;
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  border-top: 1px solid ${({ theme }) => theme.colours.canvas.secondary.main};
  gap: ${({ theme }) => theme.sizing.small};
  z-index: 2;

  button {
    height: 1.5rem;
  }
`;
PlayFinderTileFooter.displayName = 'PlayFinderTileFooter';

// background for the flyout panel
export const PlayFinderFilterConfigBg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) =>
    `rgba(0, 0, 0, ${theme.opacity.disabled})`};
  display: ${({ $display }) => $display || 'none'};
  z-index: 101;
`;
PlayFinderFilterConfigBg.displayName = 'PlayFinderFilterConfigBg';

// These are the styles for the "New Filter" flyout panel content
export const PlayFinderFilterConfigLayout = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;

  // adjustment for search input
  .ui.input {
    width: 100%;
    height: 36px;

    > i.icon {
      top: 4px;
    }
  }

  .row {
    display: flex;
    flex-direction: row;
    margin-top: ${({ theme }) => theme.sizing.large};
    height: 100%;

    // left column: parent categories
    > div:first-child {
      width: 220px;
      border-right: ${({ theme }) =>
        `1px solid ${theme.colours.canvas.secondary.main}`};
      padding-right: ${({ theme }) => theme.sizing.medium};

      button {
        width: 100%;
        border-radius: ${({ theme }) => theme.borderRadius.secondary};
        justify-content: left;
        ${({ theme }) => theme.typography.bodyRegular};
        padding: ${({ theme }) => theme.sizing.small};
        max-height: 36px;
        margin-bottom: ${({ theme }) => theme.sizing.small};
      }
    }

    // right column: child categories
    > div:last-child {
      flex: 1;
      padding: 0 ${({ theme }) => theme.sizing.medium}
        ${({ theme }) => theme.sizing.huge}
        ${({ theme }) => theme.sizing.medium};
      height: 84vh;
      overflow-y: auto;
      scrollbar-gutter: stable;

      h3 {
        ${({ theme }) => theme.typography.headingRegular};
        margin-bottom: ${({ theme }) => theme.sizing.medium};
      }

      h4 {
        ${({ theme }) => theme.typography.headingSmall};
        color: ${({ theme }) => `${theme.colours.ink.primary.main}60`};
        margin-bottom: ${({ theme }) => theme.sizing.small};
      }
    }
  }
`;
PlayFinderFilterConfigLayout.displayName = 'PlayFinderFilterConfigLayout';
